'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { useMemo } from 'react';
import Image from '@repo/ui/src/components/Image';
import { buildStaticImage } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import LanguageSelectorData from '@components/LanguageSelector/LanguageSelectorData.json';

export interface Props {
  showLabel?: boolean;
}

const LanguageSelector = ({ showLabel }: Props) => {
  const { country } = useCurrentUrl();
  const { push } = useModal(ModalID.languageSelector);

  const { title, regions } = LanguageSelectorData;

  const { countryName, language, flagImage } = useMemo(() => {
    const locales = regions?.map(({ locales }) => locales).flat() || [];
    return (
      locales?.find((_locale) => `/${_locale?.link?.link}` === country) ?? // Try to find it
      locales?.find((_locale) => _locale?.countryName === 'United States') ?? {
        // If not default to US
        countryName: '',
        language: '',
        flagImage: null,
      }
    ); // If US isn't there, don't explode.
  }, [regions, country]);

  return (
    <button
      className="tw-flex tw-items-center tw-gap-3 tra-text-web-body-s tw-text-white"
      onClick={() => push({ title, regions })}
      aria-label="open"
    >
      {flagImage && (
        <div className="tw-inline-block tw-overflow-hidden tw-relative tw-h-6 tw-w-6 tw-rounded-full">
          <Image src={buildStaticImage(flagImage)} alt={flagImage?.name} layout="fill" />
        </div>
      )}
      {showLabel && `${countryName || 'United States'} / ${language || 'English'}`}
    </button>
  );
};

export default LanguageSelector;
